export default function GoogleIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        transform="translate(0.5 0.415955)"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.54 12.6773C23.54 11.8619 23.4668 11.0778 23.3309 10.3251H12.5V14.7735H18.6891C18.4225 16.211 17.6123 17.4289 16.3943 18.2444V21.1298H20.1109C22.2855 19.1278 23.54 16.1796 23.54 12.6773Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 23.9158C15.605 23.9158 18.2081 22.886 20.1109 21.1296L16.3943 18.2442C15.3645 18.9342 14.0472 19.3419 12.5 19.3419C9.50474 19.3419 6.96951 17.319 6.06519 14.6008H2.22314V17.5803C4.11542 21.3387 8.00451 23.9158 12.5 23.9158Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.06523 14.601C5.83523 13.911 5.70455 13.174 5.70455 12.416C5.70455 11.6581 5.83523 10.921 6.06523 10.231V7.25146H2.22318C1.44432 8.80396 1 10.5603 1 12.416C1 14.2717 1.44432 16.0281 2.22318 17.5806L6.06523 14.601Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 5.48982C14.1884 5.48982 15.7043 6.07004 16.8961 7.20959L20.1945 3.91118C18.2029 2.0555 15.5997 0.915955 12.5 0.915955C8.00451 0.915955 4.11542 3.493 2.22314 7.25141L6.06519 10.231C6.96951 7.51277 9.50474 5.48982 12.5 5.48982Z"
        fill="#EA4335"
      />
    </svg>
  )
}
